import createVuexModule from '~/store/utils/createVuexModule';
import type { ShippingAddressTypeState } from '~/types/vuex/ShippingAddressType';
import { ShippingAddressType } from '~/types/checkout/ShippingAddressType';

export default createVuexModule<ShippingAddressTypeState['shippingAddressType']>({
  stateKey: 'shippingAddressType',
  initialValue: ShippingAddressType.SAME_AS_BILLING,
  mutationName: 'setShippingAddressType',
});
